import { Link } from "react-router-dom";
import { useHistory } from "@/hooks/useHistory";
import { films } from "@/mocks/films";
import type { Film } from "@/types/content";

export default function RecentlyViewed() {
  const { history } = useHistory();
  const recent = history
    .map((id) => (films as Film[]).find((film) => film.id === id))
    .filter((film): film is Film => Boolean(film))
    .slice(0, 6);

  if (recent.length === 0) return null;

  return (
    <section className="bg-background-100/60 border-y border-background-200/60">
      <div className="max-w-content mx-auto px-4 md:px-8 py-16 md:py-20">
        <div className="flex items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-xs font-label tracking-widest text-accent-500 uppercase mb-3">History</p>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">最近浏览</h2>
            <p className="text-sm text-foreground-600 mt-3">基于本机浏览记录生成，仅保存在你的设备中</p>
          </div>
          <Link
            to="/films"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-label text-foreground-700 hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            去发现更多
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {recent.map((film) => (
            <Link
              key={film.id}
              to={`/films/${film.id}`}
              className="group cursor-pointer"
            >
              <div className="aspect-[2/3] rounded-lg overflow-hidden bg-background-200 border border-background-200/70">
                <img
                  src={film.poster}
                  alt={`${film.title} 海报`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <p className="text-xs text-foreground-800 mt-2 line-clamp-1 group-hover:text-accent-500 transition-colors">
                {film.title}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}